export const signIn = (credentials) => {
	return (dispatch, getState, { getFirebase }) => {
		const firebase = getFirebase();

		firebase.auth().signInWithEmailAndPassword(
			credentials.email,
			credentials.password
		).then(() => {
			dispatch({ type: 'LOGIN_SUCCESS' })
		}).catch((err) => {
			dispatch({ type: 'LOGIN_ERROR', err })
		})
	}
}

export const signOut = () => {
	return (dispatch, getState, { getFirebase }) => {


		const firebase = getFirebase();
		window.location.replace("/signin");
		firebase.auth().signOut().then(() => {
			dispatch({ type: 'SIGNOUT_SUCCESS' });
		}).catch((err) => {
			dispatch({ type: 'SIGNOUT_ERROR', err })
		})
	}
}

export const signUp = (newUser) => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		const firebase = getFirebase();
		const firestore = getFirestore();

		firebase.auth().createUserWithEmailAndPassword(
			newUser.email,
			newUser.password
		).then((resp) => {
			const info = {
				...newUser,
				initials: newUser.firstName[0] + newUser.lastName[0]
			}
			delete info["password"]
			return firestore.collection('users').doc(resp.user.uid).set(
				info
				// 	{
				// 	firstName: newUser.firstName,
				// 	lastName: newUser.lastName,
				// 	initials: newUser.firstName[0] + newUser.lastName[0],
				// 	email: newUser.email,
				// }
			)

				.then(() => {
					const user = firebase.auth().currentUser;
					user.sendEmailVerification()
						.then(function () {
							// Email sent.
							dispatch({ type: 'SIGNUP_SUCCESS' })
						}).catch(function (error) {
							// An error happened.
							dispatch({ type: 'SIGNUP_ERROR', error })
						});
				})
		}
		)
			// .then(() => {
			// 	dispatch({ type: 'SIGNUP_SUCCESS' })
			// })
			.catch(err => {
				dispatch({ type: 'SIGNUP_ERROR', err })
			})

	}
}

export const sendVerificationEmail = () => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		const firebase = getFirebase();
		const user = firebase.auth().currentUser;
		user.sendEmailVerification()
			.then(function () {
				// Email sent.
				dispatch({ type: 'VERIFICATION_SENT_SUCCESS' })
			}).catch(function (error) {
				// An error happened.
				dispatch({ type: 'VERIFICATION_SENT_ERROR', error })
			});
	}
}


// export const signUp2 = (newUser) => {
// 	return (dispatch, getState, { getFirebase, getFirestore }) => {
// 		const firebase = getFirebase();
// 		const firestore = getFirestore();
// 		const actionCodeSettings = {
// 			// URL you want to redirect back to. The domain (www.example.com) for this
// 			// URL must be whitelisted in the Firebase Console.
// 			// url: 'https://cusaly.firebaseapp.com/signin',
// 			url: 'http://localhost:3000/signin',
// 			// This must be true.
// 			handleCodeInApp: true,

// 		};
// 		firebase.auth().sendSignInLinkToEmail(newUser.email, actionCodeSettings)
// 			.then(function () {
// 				window.localStorage.setItem('emailForSignIn', newUser.email);

// 			})
// 			// .then((resp) => {
// 			// 	return firestore.collection('users').doc(resp.user.uid).set({
// 			// 		firstName: newUser.firstName,
// 			// 		lastName: newUser.lastName,
// 			// 		initials: newUser.firstName[0] + newUser.lastName[0],
// 			// 		email: newUser.email
// 			// 	})
// 			// })
// 			.then(() => {
// 				dispatch({ type: 'SIGNUP_SUCCESS' })
// 			}).catch(err => {
// 				dispatch({ type: 'SIGNUP_ERROR', err })
// 			})
// 			.catch(function (error) {
// 				throw error;
// 			});

// 	}
// }


// export const signIn2 = (credentials) => {
// 	return (dispatch, getState, { getFirebase }) => {
// 		const firebase = getFirebase();
// 		if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
// 			var email = window.localStorage.getItem('emailForSignIn');
// 			if (!email) {
// 				email = window.prompt('Please provide your email for confirmation');
// 			}
// 			firebase.auth().signInWithEmailLink(email, window.location.href)
// 				.then(function (result) {
// 					console.log('c')
// 					window.localStorage.removeItem('emailForSignIn');
// 					dispatch({ type: 'LOGIN_SUCCESS' })
// 				})
// 				.catch(function (error) {
// 					console.log(error)
// 					dispatch({ type: 'LOGIN_ERROR', error })
// 				});
// 		}
// 	}
// }